import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './chatstyles.css'
import './machinebook.css'
import './expenses.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import "@fontsource/league-gothic"; // Defaults to weight 400
import { ChakraProvider } from '@chakra-ui/react'
import { Provider } from 'react-redux'
import store, { persistor } from './store'
import appConfig from './configs/app.config'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from './configs/msalAuthConfig'

const root = ReactDOM.createRoot(document.getElementById('root'))

const renderRoot = (msalInstance = null) => {
    if (msalInstance) {
        root.render(
            <ChakraProvider>
                <Provider store={store}>
                    <MsalProvider instance={msalInstance}>
                        <App />
                    </MsalProvider>
                </Provider>
            </ChakraProvider>
        )
    } else {
        root.render(
            <ChakraProvider>
                <Provider store={store}>
                    <App />
                </Provider>
            </ChakraProvider>
        )
    }
}

// Controls whether MSAL Azure SSO is enabled (true for prod, false for non-prod)
if (appConfig?.enableMsal === true) {
    try {
        const msalInstance = new PublicClientApplication(msalConfig)
        msalInstance.initialize().then(() => {
            renderRoot(msalInstance)
        }).catch((err) => {
            console.error('Failed to initialize MSAL, falling back to direct render:', err)
            renderRoot(null)
        })
    } catch (e) {
        console.error('Error setting up MSAL, falling back to direct render:', e)
        renderRoot(null)
    }
} else {
    renderRoot(null)
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
